const ORDER_RELATION_TYPES = Object.freeze({
    BEFORE: 'BEFORE',
    AFTER: 'AFTER'
})

export { ORDER_RELATION_TYPES }
